<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Oqrgtf/tc-custom/9781504070508.jpg?1704460303084" alt="This image is the cover for the book Time's Tide"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Time's Tide
      </h1>
      <p class="bookDescription body article font2">
        <b>A man returns to the remote fjords of Iceland to locate his father in this compelling tale of loss, belonging and the silence between fathers and sons.</b><br/><br/>When a father and son attempt to bridge the distance between them, each is drawn irresistibly to an unforgiving landscape, one that has been the scene of tragedy and loss. The son's return to the northern shore he abandoned as a young man promises the chance to heal the rift. But is it too late?<br/><br/>Arni left his remote corner of Iceland as soon as he could, seeking opportunities beyond winter and fishing. Married to an English woman, he built a life as a successful scientist but never escaped the pull of the West Fjords, the bleak landscape of his birth. When he learns his father is missing, Arni sets off to find him on a windswept spit of land lost in an angry ocean.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adrian Harvey
      </h2>
      
      <p class="authorDescription body article">Since escaping the East Midlands for the lights of the big city, Adrian Harvey has combined a career in and around government with trying to see as much of the world as he can. He has a particular love for cities and the patina of centuries that lie beneath their ever-changing surface. The stories that hang between the past and the future, or in a chance encounter on the city street, are a continual source of inspiration. He can often be found transfixed, staring along a street with an unexpected vista.  Landscape outside the city inspires him too. He is a keen hill walker and has undertaken extended routes in the Himalaya, the Andes, and in Iceland, as well as regular trips to the damp and windy upland areas of the United Kingdom. He also enjoys warmer travel, with a particular fondness for India. He retains a relentless curiosity for the world.  He lives in North London, which he believes to be the finest corner of the world's greatest city. He has written three novels: Being Someone, The Cursing Stone, and Time's Tide.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?41afa312